<div class="coming-soon">
    <h1 style="color: red;">404! Page Not Found!</h1>
    <button class="btn-primary" [routerLink]="['/home']" routerLinkActive="router-link-active"> Go to Home!</button>
</div>